export default "__VITE_ASSET__BugFiW0H__"